import { Injectable } from '@angular/core';
import { HotkeysService, Hotkey } from '@ngneat/hotkeys';
import { defer, Observable, share, filter } from 'rxjs';

const hotKeys: Record<string, Observable<KeyboardEvent>> = {};

@Injectable({
	providedIn: 'root'
})
export class VbHotkeysService {
	constructor(
		private readonly HotkeysService: HotkeysService
	){}

	//Allows sharing hotkey registrations for multiple instances of the player. Needed by the video editor.
	public registerHotkey(hotkey: Hotkey, ignoreHotkeys: boolean): Observable<KeyboardEvent> {
		const key = hotkey.keys;

		let hotKey = hotKeys[key];
		if (!hotKey) {
			hotKey = defer(() =>
				this.HotkeysService.addShortcut({ ...hotkey, preventDefault: false } as Hotkey)
			).pipe(
				share({ resetOnRefCountZero: true })
			);
			hotKeys[key] = hotKey;
		}

		return hotKey.pipe(
			filter((hkEvent: KeyboardEvent) =>
				!(hkEvent.target as HTMLElement).isContentEditable &&
					!ignoreHotkeys)
		);
	}
}
